import { createIcon } from './create-icon';

export const ShuffleIcon = createIcon(
  'ShuffleIcon',
  <>
    <path d="M16 3h5v5M4 20l17-17" />
    <path d="M21 16v5h-5M15 15l6 6M4 4l5 5" />
  </>,
);
